<template>
    <div class="separator-text text-grey border-b border-grey pb-[4px] lowercase mt-6">
        <slot />
    </div>
</template>

<script>
export default {
    name: "AtomSectionSeparatorText",
}
</script>
<style>
.separator-text {
    font-size: 12px;
    line-height: 15px;
}
</style>
